module.exports = __webpack_public_path__ + "static/media/carta_29.3888698a.jpg";